export default {
    Type: {
        Button: 1,
        Combobox: 2
    }
}